// ------------------ config (static)
/* eslint-disable-next-line no-unused-vars */
const ReviewService = (() => {
	// private var(s)
    const _typeId = ""
	const _sku = ""
	const _rating_summary= '';
	const _totalReviewCount = '';
	const _rating_total_count = '';
	const _configurable_options = ''
    /* object structure for reference
	ReviewService = {
		type_id: "",
		items: [
			{
				selectedOptions: { [option-id] : name, },
				option_id: 0,
				title: "",
				options: [
					{
						product: {
							id: "",
							name: ""
						}
					},
				]
			}
		]
	} */

	

	// private method(s)
	const _constructor = () => {
		// console.log('Config is running');
	};

	_constructor();

	// output/public
	return {
        typeId: _typeId,
		sku: _sku,
		rating_summary: _rating_summary,
		totalReviewCount: _totalReviewCount,
		rating_total_count: _rating_total_count,
		configurable_options: _configurable_options
	};
})();
